// extracted by mini-css-extract-plugin
module.exports = {"profileheader":"profile_profileheader__7Cp3H","logout":"profile_logout__1INvx","totalLoves":"profile_totalLoves__1Pwni"};